import { createSingletonMixin } from '@descope/sdk-helpers';

const baseUrlMixin = createSingletonMixin((superclass) => {
    return class BaseUrlMixinClass extends superclass {
        get baseUrl() {
            return this.getAttribute('base-url') || '';
        }
    };
});

export { baseUrlMixin };
//# sourceMappingURL=baseUrlMixin.js.map
